import React, {
  Children,
  ReactElement,
  cloneElement,
  useEffect,
  useState,
} from 'react'

export interface SelectProps {
  children?: React.ReactNode
  enableUncheck?: boolean
  defaultSelected?: string
  onChange?(value?: string | number): void
}

export default function Select({
  children,
  enableUncheck,
  defaultSelected,
  onChange,
}: SelectProps) {
  const [selected, setSelected] = useState<string | undefined>(defaultSelected)

  return (
    <>
      {Children.map(children, (child) => {
        const elem = child as ReactElement
        const key = elem?.key?.toString()
        const isActive = selected === key

        if (!elem || !key) {
          return null
        }

        return cloneElement(elem, {
          selected,
          isActive,
          onClick: () => {
            if (isActive && enableUncheck) {
              setSelected(undefined)
              return
            }
            setSelected(key)
            onChange?.(key)
          },
        })
      })}
    </>
  )
}

interface MultipleSelectProps extends Omit<SelectProps, 'onChange'> {
  onChange(values: string[]): void
  value: string[]
}

export function MultipleSelect({
  onChange,
  value,
  ...props
}: MultipleSelectProps) {
  const [selectedList, setSelectedList] = useState<string[]>(value)

  useEffect(() => {
    setSelectedList(value)
  }, [value])

  useEffect(() => {
    onChange(selectedList)
  }, [onChange, selectedList])

  return <Select onChange={handleChange}>{props.children}</Select>

  function handleChange(value: string) {
    setSelectedList((prev) => {
      const temp = [...prev]
      const index = temp.indexOf(value)
      if (index > -1) {
        temp.splice(index, 1)
        return temp
      }
      return [...temp, value]
    })
  }
}
